<template>
    <div>
        <app-clients-select-input
            v-model="clientId" 
            :label="true" 
            :placeholder="false" 
            @change="!!clientId?loadMails(clientId):notebook=[]"
        />
        <b-row class="mb-2" v-if="clientId">
            <b-col cols="12" md="6">
                <b-button variant="outline-primary" size="sm" @click="exportMails(false)" :disabled="!clientId">
                    <i class="fa fa-download" aria-hidden="true"></i> Exportar por entregar
                </b-button>
            </b-col>
            <b-col cols="12" md="6">
                <b-button variant="outline-primary" size="sm" @click="exportMails(true)" :disabled="!clientId">
                    <i class="fa fa-download" aria-hidden="true"></i> Exportar entregada
                </b-button>
            </b-col>
        </b-row>
        <b-tabs>
            <b-tab title="Por Entregar" active>
                <b-card>
                    <app-clients-mails-for-delivering v-if="mailsForDelivering"
                        :data="mailsForDelivering"
                        :on-change-page-mails-for-delivering="onChangePageMailsForDelivering"
                        :types="mailTypes"
                        :on-filter="onFilter"
                        :clean-filter="resetFilters"
                    />
                </b-card>
            </b-tab>
            <b-tab title="Entregada">
                <b-card>
                    <app-clients-mails-delivered
                        :data="mailsDelivered"
                        :see-more="seeMore"
                        :on-change-mails-delivered="onChangePageMailsDelivered"
                        :types="types"
                        :on-filter="onFilterMailsDelivered"
                        :cancel-filter="cancelFilterMailsDelivered"
                    />
                </b-card>
            </b-tab>
        </b-tabs>

         <!-- Ver detalle de la correspondencia -->
        <app-pop-up id="view-email-more-admin" title="Correspondencia">
            <div slot="body">
                <div class="row">
                    <div class="col-6">
                            <h5>Recibido el</h5>
                            <label>{{mailView.date | datetime}}</label>
                    </div>
                    <div class="col-6">
                            <h5>Duración</h5>
                            <label>{{mailView.date | duration}}</label>
                    </div>
                    <div class="col-6">
                            <h5>Tipo</h5>
                            <label>{{mailView.type}}</label>
                    </div>
                    <div class="col-6">
                            <h5>Recibido por</h5>
                            <label>{{mailView.name}}</label>
                    </div>
                    <div class="col-6">
                            <h5>Destino</h5>
                            <label>{{mailView.destination}}</label>
                    </div>
                    <div class="col-6">
                            <h5>Para</h5>
                            <label>{{mailView.owner}}</label>
                    </div>

                </div>

                <h5 style="text-align:center">
                    <label for="anotation">Notas</label>
                </h5>
                <textarea type="text" id="anotation" class="form-control" disabled="true" cols="50" rows="4" v-model="mailView.notes"></textarea>

            </div>

        </app-pop-up>
    </div>
</template>
<script>
import ClientsMailsForDelivering from './ClientsMailsForDelivering/ClientsMailsForDeliveringPage.vue';
import ClientsMailsDelivered from './ClientsMailsDelivered/ClientsMailsDeliveredPage.vue';
import vigilanceRepository from '../../../repositories/vigilance.repository';
import { mapGetters } from 'vuex';

export default {
    components: {
        appClientsMailsForDelivering: ClientsMailsForDelivering,
        appClientsMailsDelivered: ClientsMailsDelivered
    },
    data(){
        return{
            clientId: '',
            page: 1,
            mailsDelivered: {},
            mailsForDelivering: {},
            filtersMailDelivered: null,
            filtersMailDForDelivering: null,
            mailView: {
                destination: '',
                name: '',
                notes: '',
                date: '',
                type: '',
                owner: ''
            },
        }
    },
    computed: {
        ...mapGetters(['mailTypes'])
    },
    methods:{
        loadMails(){
            this.loadMailsDelivered();
            this.loadMailsForDelivering();
        },
        loadMailsDelivered(){
             const vr = Object.assign({}, vigilanceRepository);
                vr.getDeliveredMailPaged(this.clientId, this.page, this.filtersMailDelivered)
                    .then(data => {
                        this.mailsDelivered = data;
                    })
                    .catch(error => toastr.error('Ocurrió un error al cargar la correspondencias'));
        },
        onChangePageMailsDelivered(page){
            this.page = page;
            this.loadMailsDelivered();
        },
        onFilterMailsDelivered(filters){
            this.filtersMailDelivered = filters;
                this.page = 1;
                this.loadMailsDelivered();
        },
        cancelFilterMailsDelivered(){
            this.page = 1;
            this.$bus.$emit('delivered-mail-filters.clear');
            this.filtersMailDelivered = null;
            this.loadMailsDelivered();
        },
        seeMore(item) {
            Object.keys(this.mailView).map(key => this.mailView[key] = '');
            this.mailView.destination = item.destination.name;
            !!item.owner && (this.mailView.owner = item.owner.name);
            this.mailView.name = item.user.name;
            this.mailView.notes = item.notes;
            this.mailView.date = item.created_at;
            this.mailView.type = item.mail_type.name;

            this.$bus.$emit('view-email-more-admin.open');
        },
        loadMailsForDelivering(){
            const vr = Object.assign({}, vigilanceRepository);
                vr.getPendingMailPaged(this.clientId, this.page, this.filtersMailDForDelivering)
                    .then(data => {
                        this.mailsForDelivering = data;
                    })
                    .catch(error => toastr.error('Ocurrió un error al cargar la correspondencias'));
        },
        onChangePageMailsForDelivering(page){
            this.page = page;
            this.loadMailsForDelivering();
        },
        onFilter(filters){
            this.filtersMailDForDelivering = filters;
            this.loadMailsForDelivering();
        },
        resetFilters(filters){
            this.filtersMailDForDelivering = filters;
            this.loadMailsForDelivering();
        },
        exportMails(delivered) {
            if (!this.clientId) {
                toastr.error('Seleccione un cliente');
                return;
            }
            const filters = delivered ? this.filtersMailDelivered : this.filtersMailDForDelivering;
            const params = { client: this.clientId, delivered: delivered ? '1' : '0' };
            if (filters) {
                if (filters.type) params.type = filters.type;
                if (filters.destination) params.destination = filters.destination;
                if (filters.owner) params.owner = filters.owner;
                if (filters.from) params.from = filters.from;
                if (filters.to) params.to = filters.to;
            }
            const queryString = Object.keys(params)
                .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
                .join('&');
            window.location.href = `exports/mail/export-excel?${queryString}`;
        },
    },
    created(){
        this.load('mailTypes');
    }
}
</script>
